import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-col col-span-2" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_4 = { class: "flex items-center underline text-sm bg-next-gray-md-dark px-3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_SingleFileUpload = _resolveComponent("SingleFileUpload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "grid font-bold text-sm grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 mb-3" }, [
      _createElementVNode("p", null, "Tipologia"),
      _createElementVNode("p", null, "Allegato"),
      _createElementVNode("p"),
      _createElementVNode("p")
    ], -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 mb-3"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Field, {
            "label-visible": false,
            modelValue: file.id,
            "onUpdate:modelValue": ($event: any) => ((file.id) = $event),
            placeholder: "Tipologia",
            errors: _ctx.getErrors(i,'type')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Select, {
                modelValue: file.type,
                "onUpdate:modelValue": ($event: any) => ((file.type) = $event),
                options: _ctx.selectOptions
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Field, {
            "label-visible": false,
            modelValue: file.name,
            "onUpdate:modelValue": ($event: any) => ((file.name) = $event),
            placeholder: "Name",
            errors: _ctx.getErrors(i,'file_id')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SingleFileUpload, {
                file: file.file,
                "onUpdate:file": ($event: any) => ((file.file) = $event),
                accept: ".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
              }, {
                default: _withCtx(({props, methods}) => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _withDirectives(_createElementVNode("a", {
                        class: "underline text-next-atp break-words cursor-pointer",
                        onClick: ($event: any) => (_ctx.downloadFile(file?.file?.id))
                      }, [
                        _createElementVNode("span", null, [
                          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(file?.file?.name), 1)
                        ])
                      ], 8, _hoisted_5), [
                        [_vShow, file?.file?.id]
                      ]),
                      _withDirectives(_createElementVNode("span", null, "Vuoto", 512), [
                        [_vShow, !file?.file?.id]
                      ])
                    ]),
                    _createVNode(_component_NextButton, {
                      variant: "outline-secondary",
                      onClick: methods.open,
                      class: "w-full h-10 px-4 col-start-2"
                    }, {
                      default: _withCtx(() => [
                        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(file?.file? 'Cambia' : 'Allega'), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _: 2
              }, 1032, ["file", "onUpdate:file"])
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_NextButton, {
            variant: "outline-secondary",
            onClick: ($event: any) => (_ctx.remove(i)),
            class: "col flex justify-center items-center h-8 w-8"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "icon-x" }, null, -1)
            ])),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_NextButton, {
        variant: "primary",
        onClick: _ctx.add,
        class: "col flex justify-center items-center h-8 w-8"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "icon-croce_quadrata" }, null, -1)
        ])),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}